import ScreenWrapper from "@/components/ScreenWrapper"
import ProfilePage from "@/pages/profiel"
import { createFileRoute } from "@tanstack/react-router"
import { Suspense } from "react"
import { LayoutWithSidebar, Skeleton } from "toptaal-shared"

export const Route = createFileRoute("/profiel")({
  component: () => (
    <Suspense fallback={<HomePageSkeleton />}>
      <ProfilePage />
    </Suspense>
  ),
})

function HomePageSkeleton() {
  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        sidebar={
          <div className="relative bg-primary-light-blue py-4 px-6 rounded w-1/3 screen-minheight-minus-navbar">
            <Skeleton className="h-[200px]" />
            <Skeleton className="h-[280px]" />
          </div>
        }
      />
    </ScreenWrapper>
  )
}
